import { bunja } from 'bunja';
import { atom } from 'jotai';

import { isRankingType } from '@flipster/apis/v2/trading-competition/types';
import Num from '@flipster/utils/num';

import { competitionApiBunja, competitionBunja, competitionTabsBunja } from '../../state';
import type { MilestoneDataSource, MilestoneStatus } from './state';

export const competitionMilestoneDataSourceBunja = bunja(() => {
  const { competitionAtom } = bunja.use(competitionBunja);
  const { competitionStatusAtom } = bunja.use(competitionApiBunja);
  const { selectedEventTabValueAtom } = bunja.use(competitionTabsBunja);

  const statusAtom = atom((get) => get(competitionStatusAtom) as MilestoneStatus);

  const currentMilestoneValueAtom = atom((get) => Num(get(competitionAtom)?.currentMilestoneValue || 0));

  const maxPrizePoolAtom = atom((get) => {
    const milestoneType = get(selectedEventTabValueAtom);
    if (!isRankingType(milestoneType)) return Num(0);
    return Num(get(competitionAtom)?.maxPrizePool[milestoneType] || 0);
  });

  const milestonesAtom = atom((get) => {
    const milestoneType = get(selectedEventTabValueAtom);
    const obj = get(competitionAtom)?.milestones;
    if (!isRankingType(milestoneType)) return [];
    const arr = obj?.[milestoneType] || [];
    return arr.map(({ prize, value }) => ({ prize: Num(prize), value: Num(value) }));
  });

  const dataSource: MilestoneDataSource = {
    statusAtom,
    currentMilestoneValueAtom,
    maxPrizePoolAtom,
    milestonesAtom,
  };

  return { dataSource };
});
competitionMilestoneDataSourceBunja.debugLabel = 'competitionMilestoneDataSourceBunja';
